// src/components/Footer.tsx
import React from "react";
import { Link } from "react-router-dom";
import { FiMail } from "react-icons/fi";

const Footer: React.FC = () => {
	return (
		<footer className="bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
			<div className="container mx-auto px-4 py-12">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
					{/* サービス情報 */}
					<div className="space-y-4">
						<h3 className="text-lg font-bold text-gray-900 dark:text-white">
							b+ ticket
						</h3>
						<p className="text-sm text-gray-600 dark:text-gray-400">
							イベントチケットの販売・管理を簡単に。主催者と参加者をつなぐチケットプラットフォーム。
						</p>
					</div>

					{/* サービス */}
					<div className="space-y-4">
						<h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
							サービス
						</h3>
						<ul className="space-y-2">
							<li>
								<Link
									to="/events"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									イベント一覧
								</Link>
							</li>
							<li>
								<Link
									to="/organizer/start"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									主催者登録
								</Link>
							</li>
							<li>
								<Link
									to="/help"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									ヘルプセンター
								</Link>
							</li>
						</ul>
					</div>

					{/* 法的情報 */}
					<div className="space-y-4">
						<h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
							法的情報
						</h3>
						<ul className="space-y-2">
							<li>
								<Link
									to="/terms-of-service"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									利用規約
								</Link>
							</li>
							<li>
								<Link
									to="/terms-for-organizers"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									主催者利用規約
								</Link>
							</li>
							<li>
								<Link
									to="/privacy-policy"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									プライバシーポリシー
								</Link>
							</li>
							<li>
								<Link
									to="/commercial-transaction"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									特定商取引法に基づく表記
								</Link>
							</li>
							<li>
								<Link
									to="/cancellation-policy"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									キャンセル・返金ポリシー
								</Link>
							</li>
							<li>
								<Link
									to="/cookie-policy"
									className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									Cookieポリシー
								</Link>
							</li>
						</ul>
					</div>

					{/* お問い合わせ */}
					<div className="space-y-4">
						<h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
							お問い合わせ
						</h3>
						<ul className="space-y-2">
							<li className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
								<FiMail className="w-4 h-4" />
								<a
									href="mailto:info@blackadder.co.jp"
									className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
								>
									info@blackadder.co.jp
								</a>
							</li>
						</ul>
						<div className="pt-4">
							<p className="text-xs text-gray-500 dark:text-gray-500">
								合同会社blackadder
							</p>
						</div>
					</div>
				</div>

				{/* コピーライト */}
				<div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
					<p className="text-center text-sm text-gray-600 dark:text-gray-400">
						© {new Date().getFullYear()} blackadder LLC. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
